import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b8bc867"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "hd-content-svg__placeholder placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hd-content-svg", `hd-content-svg__${_ctx.endpointId}`])
  }, [
    (_ctx.svgContent)
      ? (_openBlock(), _createBlock(_component_lyra_asset, {
          key: 0,
          "asset-key": _ctx.svgContent
        }, null, 8, ["asset-key"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, "No SVG Found"))
  ], 2))
}